/**
 * Weeboholic - About Us Interactive Scripts
 * Handles coupon copy and interactive state transitions
 */
(function initWeebAboutPage() {
  'use strict';

  function handleCopyClick(event) {
    const trigger = event.currentTarget;
    if (!trigger) return;

    const couponCode = trigger.getAttribute('data-coupon-code') || 'WEEB10';

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(couponCode)
        .then(() => updateButtonState(trigger, true))
        .catch(() => fallbackCopy(couponCode, trigger));
    } else {
      fallbackCopy(couponCode, trigger);
    }
  }

  function fallbackCopy(text, trigger) {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      updateButtonState(trigger, true);
    } catch (err) {
      console.warn('Unable to copy coupon code', err);
    }
  }

  function updateButtonState(trigger, isSuccess) {
    if (!isSuccess) return;

    const originalText = trigger.getAttribute('data-default-text') || 'Copy Code';
    trigger.classList.add('is-copied');
    trigger.textContent = 'Copied! ✓';

    window.setTimeout(() => {
      trigger.classList.remove('is-copied');
      trigger.textContent = originalText;
    }, 2500);
  }

  function initAboutUsInteractions() {
    const copyButtons = document.querySelectorAll('[data-about-copy-btn]');
    copyButtons.forEach((button) => {
      button.addEventListener('click', handleCopyClick);
    });

    // Check if duplicate default page title exists and hide it cleanly
    const aboutPageContainer = document.querySelector('[data-weeb-about-page]');
    if (aboutPageContainer) {
      const sectionWrapper = aboutPageContainer.closest('.section-content-wrapper');
      if (sectionWrapper) {
        const defaultTitleBlock = sectionWrapper.querySelector('.text-block:first-child');
        if (defaultTitleBlock && !defaultTitleBlock.contains(aboutPageContainer)) {
          defaultTitleBlock.style.display = 'none';
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAboutUsInteractions, { once: true });
  } else {
    initAboutUsInteractions();
  }
})();
